var exports = {
  "zr": "x31de4314--bea3a7--root",
  "nM": "x31de4314--bea3a7--row",
  "fJ": "x31de4314--bea3a7--cellFloor",
  "T$": "x31de4314--bea3a7--cellType",
  "Sq": "x31de4314--bea3a7--cellArea",
  "o4": "x31de4314--bea3a7--cellPrice",
};

module.exports = exports;
